module.exports = __webpack_public_path__ + "static/media/president2.ec909356.jpeg";